import {createApp} from 'vue'
import MoveFileOverlay from './MoveFileOverlay'

const el = '.kb-component--move-file-overlay'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((MoveFileOverlayDOM)=>{
            const component = createApp(MoveFileOverlay).use(Store)
            component.mount(MoveFileOverlayDOM)
        })
    }
}